var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 75,
    viewBox: "0 0 127 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10_364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.738 62.1654L110.334 45.2423C110.014 44.4173 109.224 43.8462 108.328 43.8462H99.1274L93.2571 28.3192C92.9369 27.4942 92.1471 26.9231 91.2506 26.9231H82.0502L76.18 11.3962C75.8598 10.5712 75.07 10 74.1734 10H52.4214C51.6743 10.1481 51.0766 10.6769 50.8204 11.3962L44.9502 26.9231H35.5577C34.7252 27.0077 34.0208 27.5577 33.7433 28.3192L27.873 43.8462H18.2671C17.52 43.9942 16.9223 44.5231 16.6662 45.2423L10.2622 62.1654C9.85664 63.2654 10.433 64.4712 11.543 64.8731C11.7778 64.9577 12.0126 65 12.2688 65H114.732C115.906 65 116.866 64.0481 116.866 62.8846C116.866 62.6519 116.824 62.3981 116.738 62.1654ZM89.7777 31.1538L94.5806 43.8462H66.5741L71.377 31.1538H89.7777ZM63.5002 39.9538L60.1702 31.1538H66.8302L63.5002 39.9538ZM54.2999 14.2308H72.7005L77.5035 26.9231H49.497L54.2999 14.2308ZM37.2228 31.1538H55.6234L60.4263 43.8462H32.4198L37.2228 31.1538ZM15.3427 60.7692L20.1456 48.0769H38.5462L43.3492 60.7692H15.3427ZM43.093 48.0769H49.7531L46.4231 56.8769L43.093 48.0769ZM49.497 60.7692L54.2999 48.0769H72.7005L77.5035 60.7692H49.497ZM77.2473 48.0769H83.9074L80.5773 56.8769L77.2473 48.0769ZM83.6512 60.7692L88.4542 48.0769H106.855L111.658 60.7692H83.6512Z",
    fill: "#00B0F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M77.5033 26.9231H49.4968L54.2998 14.2308H72.7004L77.5033 26.9231Z",
    fill: "#10183C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M60.4262 43.8461H32.4197L37.2226 31.1538H55.6232L60.4262 43.8461Z",
    fill: "#10183C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M49.7531 48.077L46.4231 56.877L43.093 48.077H49.7531Z",
    fill: "#10183C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M83.9074 48.077L80.5774 56.877L77.2473 48.077H83.9074Z",
    fill: "#10183C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M94.5805 43.8461H66.574L71.3769 31.1538H89.7775L94.5805 43.8461Z",
    fill: "#10183C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M111.658 60.7693H83.6514L88.4543 48.077H106.855L111.658 60.7693Z",
    fill: "#10183C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M77.5033 60.7693H49.4968L54.2998 48.077H72.7004L77.5033 60.7693Z",
    fill: "#10183C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M43.349 60.7693H15.3425L20.1455 48.077H38.5461L43.349 60.7693Z",
    fill: "#10183C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10_364",
    x: 0.132324,
    y: 0,
    width: 126.734,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.690196 0 0 0 0 0.94902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10_364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10_364",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group3.4171266978fef89196bcb92e19c23d01.svg";
export { ForwardRef as ReactComponent };